export default __webpack_public_path__ + "static/media/Warning.9f86fe88.gif";